import SearchComponent from '../SearchComponent/SearchComponent.vue'
import spinner from '../LoadingComponent/LoadingComponent.vue'
export default {
  name: 'responsiveheader',
  components: {
    searchcomponent: SearchComponent,
    spinner,
  },
  props: [],
  data () {
    return {
      tokenValid: false,
      isLoading: false,
    }
  },
  computed: {

  },
  mounted () {
    //this.buttonActivation('nav-bar-header','btnHeader');
  },
  watch: { // function that monitors if variable is token is valid
    tokenValid: function (val) {
      if (val == true){
        this.$router.push("/portfolios");
      }
    } 
  },
  methods: {
    checkLogin: async function(){
      this.isLoading = true;
      try{
        document.getElementsByClassName("landingpage")[0].style.background = 'hsla(0, 0%, 100%, 0.40);'
        document.getElementsByClassName("landingpage")[0].style.zIndex = '99999'
      }catch{
        console.log("other page than landing page")
      }
      await this.verifyToken()
      this.isLoading = false;
    }
    
  },
}


